"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = exports.DRAWER_SIZES = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var Paper_1 = require("../Paper/Paper");
var Overlay_1 = require("../Overlay/Overlay");
var Transition_1 = require("../Transition/Transition");
var Drawer_styles_1 = __importStar(require("./Drawer.styles"));
exports.DRAWER_SIZES = Drawer_styles_1.sizes;
var transitions = {
    top: 'slide-down',
    bottom: 'slide-up',
    left: 'slide-right',
    right: 'slide-left',
};
function Drawer(_a) {
    var opened = _a.opened, onClose = _a.onClose, className = _a.className, themeOverride = _a.themeOverride, _b = _a.position, position = _b === void 0 ? 'left' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.noFocusTrap, noFocusTrap = _d === void 0 ? false : _d, _e = _a.noScrollScroll, noScrollScroll = _e === void 0 ? false : _e, _f = _a.noCloseOnClickOutside, noCloseOnClickOutside = _f === void 0 ? false : _f, _g = _a.noCloseOnEscape, noCloseOnEscape = _g === void 0 ? false : _g, transition = _a.transition, _h = _a.transitionDuration, transitionDuration = _h === void 0 ? 250 : _h, _j = _a.transitionTimingFunction, transitionTimingFunction = _j === void 0 ? 'ease' : _j, _k = _a.zIndex, zIndex = _k === void 0 ? 1000 : _k, overlayColor = _a.overlayColor, overlayOpacity = _a.overlayOpacity, children = _a.children, _l = _a.noOverlay, noOverlay = _l === void 0 ? false : _l, _m = _a.shadow, shadow = _m === void 0 ? 'md' : _m, _o = _a.padding, padding = _o === void 0 ? 0 : _o, others = __rest(_a, ["opened", "onClose", "className", "themeOverride", "position", "size", "noFocusTrap", "noScrollScroll", "noCloseOnClickOutside", "noCloseOnEscape", "transition", "transitionDuration", "transitionTimingFunction", "zIndex", "overlayColor", "overlayOpacity", "children", "noOverlay", "shadow", "padding"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var duration = hooks_1.useReducedMotion() ? 1 : transitionDuration;
    var classes = Drawer_styles_1.default({ theme: theme, size: size, position: position });
    var focusTrapRef = hooks_1.useFocusTrap(!noFocusTrap);
    hooks_1.useScrollLock(opened && !noScrollScroll);
    var clickOutsideRef = hooks_1.useClickOutside(function () { return opened && !noCloseOnClickOutside && onClose(); });
    var drawerTransition = transition || transitions[position];
    var _overlayOpacity = typeof overlayOpacity === 'number'
        ? overlayOpacity
        : theme.colorScheme === 'dark'
            ? 0.85
            : 0.75;
    var closeOnEscape = function (event) {
        if (noFocusTrap && event.code === 'Escape' && !noCloseOnEscape) {
            onClose();
        }
    };
    // eslint-disable-next-line consistent-return
    react_1.useEffect(function () {
        // onKeyDownCapture event will not fire when focus trap is not active
        if (noFocusTrap) {
            window.addEventListener('keydown', closeOnEscape);
            return function () { return window.removeEventListener('keydown', closeOnEscape); };
        }
    }, [noFocusTrap]);
    return (react_1.default.createElement(Transition_1.GroupedTransition, { mounted: opened, transitions: {
            overlay: { duration: duration / 2, transition: 'fade', timingFunction: 'ease' },
            drawer: {
                duration: duration,
                transition: drawerTransition,
                timingFunction: transitionTimingFunction,
            },
        } }, function (styles) {
        var _a;
        return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.wrapper, (_a = {}, _a[classes.noOverlay] = noOverlay, _a), className), role: "dialog", "aria-modal": true }, others),
            react_1.default.createElement(Paper_1.Paper, { className: clsx_1.default(classes.drawer, className), elementRef: hooks_1.useMergedRef(focusTrapRef, clickOutsideRef), style: __assign(__assign({}, styles.drawer), { zIndex: zIndex + 1 }), radius: 0, tabIndex: -1, onKeyDownCapture: function (event) {
                    return event.nativeEvent.code === 'Escape' && !noCloseOnEscape && onClose();
                }, shadow: shadow, padding: padding, themeOverride: themeOverride }, children),
            !noOverlay && (react_1.default.createElement("div", { style: styles.overlay },
                react_1.default.createElement(Overlay_1.Overlay, { opacity: _overlayOpacity, zIndex: zIndex, color: overlayColor ||
                        (theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.black) })))));
    }));
}
exports.Drawer = Drawer;
Drawer.displayName = '@mantine/core/Drawer';
